/** AI 评分维度 code → 中文名称，与 WorklogLocalizationService / 复核页保持一致。 */
const AI_DIMENSION_LABELS = Object.freeze({
  metric_relevance: '量化指标相关性',
  work_fact_completeness: '工作事实完整度',
  result_data_clarity: '结果数据清晰度',
  execution_depth: '执行深度',
  evidence_traceability: '证据可追溯性',
  visual_quality: '视觉与音画质量',
  delivery_timeliness: '修改导出与交付时效',
  asset_archiving: '素材与工程文件归档',
  content_planning: '内容策划与传播',
  channel_operation: '渠道运营与投放',
  brand_interaction: '品牌互动与舆情',
  sales_process: '销售过程质量',
  channel_quality: '渠道开发质量',
  meeting_reception: '会务接待',
  payment_review: '收支与报销审核',
  accounting_compliance: '财务税务与合规',
  reconciliation_assets: '对账与资产管理',
  reporting_support: '销售收款汇报与经营支持',
  reception_service: '接待服务',
  environment_service: '环境与会务保障',
  logistics_execution: '后勤执行与响应',
  recruitment_process: '招聘过程与到岗转化',
  retention_management: '员工留存跟进与风险处置',
  personnel_compliance: '人事手续与协同质量',
  market_user_research: '市场调研、用户需求与产品规划',
  project_delivery: '项目全流程进度、质量与风险管理',
  testing_acceptance: '产品测试、功能校验与上线验收',
  ai_innovation: 'AI与大模型场景融合及创新落地',
  cross_department_delivery: '跨部门协同、上线与常态化运营',
  requirement_solution_delivery: '需求分析、技术方案与按期交付',
  full_stack_implementation: '前后端功能开发、接口联调与代码质量',
  testing_release_quality: '测试、缺陷修复、发布与验收质量',
  stability_performance_security: '部署运维、稳定性、性能、数据与安全',
  collaboration_documentation: '跨部门协同、技术文档与知识沉淀',
  ui_interface_design: 'Web、H5、小程序及后台UI界面设计',
  interaction_visual_solution: '需求讨论、交互与视觉方案',
  prototype_high_fidelity: '产品原型与高保真设计稿转化',
  implementation_acceptance: '前端还原配合与视觉验收',
  design_system: 'UI规范、组件、色彩与字体体系',
  ux_optimization: '基于数据反馈的用户体验优化',
  graphic_vi_material: '海报、VI及宣传物料设计'
});

function toSnakeCase(code) {
  return String(code || '')
    .replace(/([A-Z])/g, '_$1')
    .replace(/^_/, '')
    .toLowerCase();
}

export function aiDimensionLabel(code, fallbackName) {
  if (fallbackName) return fallbackName;
  if (!code) return '';
  const raw = String(code);
  return AI_DIMENSION_LABELS[raw]
    || AI_DIMENSION_LABELS[toSnakeCase(raw)]
    || raw;
}

export default AI_DIMENSION_LABELS;



// WEBPACK FOOTER //
// ./src/utils/aiDimensionLabels.js